import { g as getLanguageCode } from './get-language-code.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Evolution by GuestCentric**
 *
 * Example: <a href="http://be.evodist.com/Rooms/hotel/HotelLAbbaye-Talloires/lang/fr-FR/arrival/2018-11-07/nights/1" target="_blank">Abbaye de Talloires</a>
 *
 * @exports bs_183
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_183
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      var aux;

      aux = window.location.pathname.match(ctx.urlRe);
      if (aux && ctx.langs.test(aux[1])) {
        resolve(aux[1]);
        return;
      }

      aux = (document.getElementsByTagName('body')[0].getAttribute('class') || '').split(/\s+/).filter(function (name) {
        return ctx.langs.test(name);
      }).reverse();
      if (aux.length) {
        resolve(aux[0]);
        return;
      }
      aux = window.location.pathname.match(/\/\w{2}-\w{2}/);
      aux = aux && aux.length > 0 ? aux[0].substr(1, 2) : '';
      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      thn.domReady().then(function () {

        aux = document.getElementById('bgLanguageSelector');
        aux = aux && (aux.innerText || aux.textContent);
        aux = aux && getLanguageCode(aux);
        if (aux) {
          resolve(aux);
          return;
        }

        aux = thn.parseUrlParameter('apikey');
        if (aux && aux === '1978f92db75d9d9856bae7947f3621c3') {
          resolve('es');
          return;
        }
        if (aux && aux === '0d08c1fd08d282bd0b52a22b017418f0') {
          resolve('en');
          return;
        }

        aux = Array.from(document.getElementsByTagName('meta')).filter(function (meta) {
          return meta.getAttribute('http-equiv') === 'content-language';
        });
        aux = aux && aux.length && aux[0].getAttribute('content');
        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }
        // Property example - 1014245
        const $ = window.jQuery;
        aux = $ && $('#divLangues').length;
        if (aux) {
          aux = $('.linkLangue').text() || 'en';
          resolve(aux);
          return;
        }

        reject('no_language');
      });

    });
  };

  /**
     * @memberOf module:bs_10
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    var $ = window.jQuery;
    var searchSelector = '#ajaxRooms';
    var $roomsDiv = $(searchSelector);

    if ($roomsDiv.length && !thn.evolution) {

      thn.evolution = thn.debounce(function thnEvolutionUpdate() {
        thn.languageCheck().then(function ({ changed }) {
          if (!changed && ctx.widget.refresh() && !ctx.widget.isSet()) {
            ctx.widget.hide();
          }
        });
      }, 300);

      thn.observeDom($roomsDiv.get(0), thn.evolution, {
        childList: true,
        subtree: false,
        characterData: false,
        attributes: false,
      });

      thn.pageUnload(function () {
        thn.stopObserveDom($roomsDiv.get(0), thn.evolution);
        delete thn.evolution;
      });
    }
  };

  /**
     * Implements **noRooms**.
     *
     * @memberOf module:bs_183
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    var widgetData = {};
    var $price;
    var prices;
    var nights;
    var $ = window.jQuery;

    if (!$) {
      this.logger.warn('jQuery not found');
      return;
    }
    if (window.location.pathname.match(/mobile/).length) {
      /** Mobile Version */
      widgetData.dateBegin = translateDate($('.arrivalDate').eq(0).text(), thn.data.language);
      widgetData.dateEnd = translateDate($('.departureDate').eq(0).text(), thn.data.language);
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.nights = nights;
      widgetData.rooms = 1;
      widgetData.adults = $('.adultsOcc').eq(0).text() || 2;
      widgetData.children = $('.childrenOcc').eq(0).text() || 0;
      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

      // Default Hotel currency is EUR
      widgetData.currency = thn.getCurrencyCode($('.currencyPrefix').eq(0).text() || '€');

      if ($('.noAvailabiltiy:visible').length) {

        widgetData.noRooms = true;

      } else {

        $price = $('.priceSpan.isPrice');
        if ($price.length) {
          prices = $price.map(function (key, e) {
            // return thn.parse_sentence_for_number($(e).eq(0).text());
            return $(e).eq(0).text();
          }).toArray();

          if (prices.length) {
            widgetData.price = Math.min(...prices);
            widgetData.set = true;
          }
        }
      }
    } else {
      /** Desktop Version */
      widgetData.dateBegin = translateDate($('#jqDateArr').val(), thn.data.language);
      widgetData.dateEnd = translateDate($('#jqDateDep').val(), thn.data.language);
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.nights = nights;
      widgetData.rooms = 1;
      /*
             * This hotel does not let you choose the number of adults or children for the search.
             * The default numbers are 2 - 0, and then, one the rooms are shown, you can choose
             * between the number of guests for each room. Price does not change for 1 or 2 adults,
             * or even more children, so we are taking that default numbers, the ones that the
             * system uses to filter for the first time.
             */
      widgetData.adults = 2;
      widgetData.children = 0;
      widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);

      // Default Hotel currency is EUR
      widgetData.currency = $('.currencyPrefix').eq(0).text() || 'EUR';

      if ($('.noAvailabiltiy:visible').length) {

        widgetData.noRooms = true;

      } else {

        $price = $('.priceSpan.isPrice');
        if ($price.length) {
          prices = $price.map(function (key, e) {
            // return thn.parse_sentence_for_number($(e).eq(0).text());
            return $(e).eq(0).text();
          }).toArray();

          if (prices.length) {
            widgetData.price = Math.min(...prices);
            widgetData.set = true;
          }
        }
      }
    }

    return widgetData;
  };

  /**
     * Implements **bookingId**.
     *
     * @memberOf module:bs_183
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    var widgetData = {};

    if (window.location.pathname.match(/mobile/).length) {
      /**
             * Mobile Version
             * From mobile we can only get the Booking ID.
             * There are no internal JS variables.
             */

      widgetData.bookingId = thn.parseUrlParameter('reservationCode');

    } else {
      /** Desktop Version */
      widgetData.price = window.totalRoomCost;
      widgetData.adults = parseInt(window.adultCount, 10);
      widgetData.rooms = 1;
      widgetData.currency = 'EUR';
      widgetData.dateBegin = window.arrival.replace(/-/g, '/');
      widgetData.dateEnd = window.departure.replace(/-/g, '/');
      widgetData.bookingId = window.reservationCode;
    }

    return widgetData;
  };

  return engine;

}

export { factory };
